enum PORTAL_URL {
	NOTREDAME = 'https://portal-beneficiario.notredame.com.br/',
	GNDI = 'https://portal-beneficiario.gndi.com.br/',
}

export {PORTAL_URL};
